import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import NSWhatsapp_orderStatusChange from "./NSWhatsapp_orderStatusChange";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <input
      id="search"
      type="search"
      placeholder="Search by Email, Name, Phone"
      aria-label="Search Input"
      defaultValue={filterText}
      onChange={onFilter}
      className="w-25 form-control float-left"
      autoComplete="off"
    />
    {/* <button type="button" className="btn bg-black text-white mr-5" onClick={onClear} disabled>
     <MdSearch/>
    </button> */}
  </>
);

const NourishWhatsappOrder = () => {
  const nourishmedusatoken = JSON.parse(localStorage.getItem("NStoken"));
  const [UserData, setUserData] = useState();
  const [pending, setPending] = useState(true);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");
  const filterProperties = ["email", "name", "id", "phone"];
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPending(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    // return (
    //   <div className="SubFilterheader w-100 d-inline border p-3">
    //     <FilterComponent
    //       onFilter={(e) => setFilterText(e.target.value)}
    //       onClear={handleClear}
    //       filterText={filterText}
    //       className=""
    //     />
    //   </div>
    // );
  }, [filterText, resetPaginationToggle]);

  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer f47ac10b58cc4372a5670e02b2c3d4e5`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://vaaradhi-dev.agrani.tech/commgrid/api/orders",
          requestOptions
        );
        const result = await response.json();
        setUserData(result);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData(page, limit);
  }, [page, limit]);

  const columns = [
    {
      name: "S. No.",
      selector: (row) => row.i,
      sortable: true,
      grow: 1,
    },
    {
      name: "Date",
      selector: (row) => format(new Date(row.created_at), "MM/dd/yyyy"),
      sortable: true,
    },
    // {
    //   name: "Channel Type",
    //   selector: (row) => row?.chaneltype,
    //   sortable: true,
    // },
    {
      name: "Order id",
      selector: (row) => row.order_id,
      grow: 3,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => (row?.name === null ? "" : row?.name),
      sortable: false,
      wrap: true,
      grow: 2,
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      grow: 2,
    },
    {
      name: "Address",
      selector: (row) => row?.shipping_details,
      grow: 2,
      wrap: true,
    },
    {
      name: "Total Amount",
      selector: (row) =>
        Number(row?.total_amount || 0) + Number(row?.shipping_amount || 0),
      sortable: false,
      // grow: 2,
    },
    {
      name: "Voucher",
      selector: (row) => row?.voucher,
      sortable: false,
      // grow: 2,
    },
    {
      name: "Product Name",
      grow: 3,
      wrap: true,
      selector: (row) => row.Product,
    },
    {
      name: "Payment Status",
      selector: (row) => (
        <b
          className={`${
            row.payment_status === "Paid" ? "text-success" : "text-danger"
          }`}
        >
          {row.payment_status}
        </b>
      ),
      // sortable: true,
    },
    {
      name: "Order Status",
      grow: 4,
      // sortable: true,
      selector: (row) =>
        row.payment_status === "Paid" ? (
          <NSWhatsapp_orderStatusChange
            WAPtoken={"Bearer f47ac10b58cc4372a5670e02b2c3d4e5"}
            orderId={row?.id}
            orderStatus={row?.order_status}
          />
        ) : (
          <b className="text-danger">Payment not received yet</b>
        ),
    },
  ];

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };

  const Tabledata = UserData?.data
    // .filter((item) =>
    //   filterProperties.some(
    //     (property) =>
    //       item[property] &&
    //       item[property].toLowerCase().includes(filterText.toLowerCase())
    //   )
    // )
    .map((item, index) => ({
      i: index + 1,
      created_at: item?.created_at,
      order_id: item?.order_id,
      id: item?.id,
      name: item.customer_name,
      phone: item?.customer_phone,
      total_amount: item?.overall_amount,
      order_status: item?.order_status,
      payment_status: item?.payment_status,
      shipping_amount: item?.shipping_amount,
      chaneltype: "Whatsapp",
      voucher: item.voucher.code,
      Product: item?.products.map(
        (name) => " " + name.quantity + " x " + name.item_name + ","
      ),
      shipping_details:
        item.shipping_address !== null
          ? item.shipping_address?.address +
            " " +
            item.shipping_address?.pincode
          : null,
    }));

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <DataTable
            columns={columns}
            data={Tabledata}
            defaultSortAsc={true}
            progressPending={pending}
            paginationTotalRows={totalRows}
            paginationPerPage={limit}
            // onChangeRowsPerPage={handleRowsPerPageChange}
            // onChangePage={handlePageChange}
            subHeader
            paginationRowsPerPageOptions={[10, 50, 150, 250, 350]}
            subHeaderComponent={subHeaderComponentMemo}
            persistTableHead
            pagination
            paginationComponentOptions={{
              rowsPerPageText: "Rows per page:",
              rangeSeparatorText: "of",
              selectAllRowsItem: true,
              selectAllRowsItemText: "All",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NourishWhatsappOrder;
